import { useMemo } from "react";
import { ResponsiveValue, Button } from "@chakra-ui/react";
import { Property } from "csstype";

interface PartBayButtonInterface {
    colorScheme: 'partbay-blue';
    variant: 'solid' | 'outline';
    text: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    isLoading?: boolean;
    isDisabled?: boolean;
    loadingText?: string;
    size?: ResponsiveValue<(string & {}) | "sm" | "md" | "lg" | "xs">;
    leftIcon?: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
    alignSelf?: ResponsiveValue<Property.AlignSelf>;
}

const PartBayButton = ({
    colorScheme,
    variant,
    onClick,
    leftIcon,
    alignSelf,
    text,
    size,
    isLoading,
    isDisabled,
    loadingText
}: PartBayButtonInterface) => {

    const { bg, hover, active, color, borderColor, hoverColor, activeColor }: Record<string, ResponsiveValue<Property.Color>> = useMemo(() => {
        if (colorScheme === 'partbay-blue') {
            if (variant === 'solid') return {
                bg: '#0071E3',
                hover: '#005BC4',
                active: '#00469B',
                color: 'white',
                borderColor: 'transparent',
                hoverColor: 'white',
                activeColor: 'white'
            };
            if (variant === 'outline') return {
                bg: 'transparent',
                hover: '#E6F1FD',
                active: '#005BC4',
                color: '#0071E3',
                borderColor: '#0071E3',
                hoverColor: '#0071E3',
                activeColor: 'white'
            };
        }
        return {
            bg: 'white',
            hover: 'white',
            active: 'white',
            color: 'white',
            borderColor: 'transparent',
            hoverColor: 'white',
            activeColor: 'white'
        };
    }, [colorScheme, variant]);

    return (
        <Button
            isLoading={isLoading}
            size={size}
            leftIcon={leftIcon}
            bg={bg}
            color={color}
            borderColor={borderColor}
            borderWidth={variant === 'outline' ? '1px' : '0px'}
            _hover={{
                bg: hover,
                color: hoverColor,
            }}
            _active={{
                bg: active,
                color: activeColor,
            }}
            onClick={onClick}
            alignSelf={alignSelf}
            isDisabled={isDisabled}
            loadingText={loadingText}
        >
            {text}
        </Button>
    );
};

export default PartBayButton;